module.exports = __webpack_public_path__ + "IMG_8337.67851a752712fbec0879.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding/andy_jeska/600x600/IMG_8337.jpg
// module id = ./src/assets/images/wedding/andy_jeska/600x600/IMG_8337.jpg
// module chunks = main